import { BoxProps, Flex, Text } from "@chakra-ui/react";
import { TimeIcon } from "@chakra-ui/icons";
import { DateTime } from "luxon";

export interface TimerBadgeProps extends BoxProps {
  availableUntil?: string | null;
}

export function TimerBadge({ availableUntil, ...props }: TimerBadgeProps) {
  const getTimeBadgeText = () => {
    if (!availableUntil) return null;

    // Handle both ISO format (2030-09-30T01:17:00) and space-separated format (2030-09-30 01:17:00)
    const normalizedDate = availableUntil.includes("T")
      ? availableUntil
      : availableUntil.replace(" ", "T");

    const date = DateTime.fromISO(normalizedDate);

    if (!date.isValid) {
      console.warn("TimerBadge: Invalid date format:", availableUntil);
      return null;
    }

    const now = DateTime.now();
    const daysRemaining = Math.floor(date.diff(now, "days").days);
    if (daysRemaining <= 0) return null;
      if (daysRemaining === 1) return "Ends Today";
    return `${daysRemaining} day${daysRemaining > 1 ? "s" : ""} left`;
  };

  const timeBadgeText = getTimeBadgeText();

  if (!timeBadgeText) return null;

  return (
    <Flex
      align="center"
      gap={1}
      px={2}
      py={1}
      borderRadius="full"
      border="1px solid"
      borderColor="transparent.white.20"
      bg="transparent"
      color="neutral.400"
      {...props}
    >
      <TimeIcon boxSize="12px" aria-label="time left" />
      <Text
        fontSize="10px"
        fontWeight="500"
        lineHeight="15px"
        letterSpacing="0.5px"
      >
        {timeBadgeText}
      </Text>
    </Flex>
  );
}
